import React, { useState, useEffect } from 'react'
import { DataForm, LoaderInfo } from '../../../../../libs/react-mpk/components'
import { number, utils } from '../../../../../libs/react-mpk/services'
import { storage } from '../../../../../services'
import t from 'counterpart'
import { inject, observer } from 'mobx-react'

const generate = () => {
  let data = storage.generate(storage.keys.SPT_1770_DETAIL_LAMP_IVB, {
    daftarKewajiban: []
  })

  return data
}

const { inputTypes } = DataForm
const DetailLampIVB = (props) => {
  const [ready, setReady] = useState(false)
  const [defaultData, setDefaultData] = useState({})
  useEffect(() => {
    let defData = storage.get(storage.keys.SPT_1770_DETAIL_LAMP_IVB)
    setDefaultData(defData)
    setReady(true)
  }, [])

  return ready ? (
    <DataForm
      baseId="spt-1770-header-lamp-IVAB"
      className="mpk-padding-NONE padding-all"
      style={{
        width: '100%',
        maxWidth: 800,
      }}
      asDialog={false}
      defaultData={defaultData}
      definitions={[
        {
          inputType: inputTypes.LIST,
          label: t.translate('column.daftarKewajiban'),
          key:'daftarKewajiban',
          defaultData: {
            kodeUtang: props.envStore.env.spt.KODE_UTANG[0].value,
            namaPemberiPinjaman: "",
            alamatPemberiPinjaman: "",
            tahunPinjaman: "",
            jumlahPinjaman: ""
          },
          definitions:[
            {
              inputType: inputTypes.SELECT,
              label: t.translate('modules.submission.sptForm.1770.DetailLampIVB.JENIS_UTANG'),
              key: 'kodeUtang',
              options: props.envStore.env.spt.KODE_UTANG,
              required: true
            },
            {
              inputType: inputTypes.INPUT,
              label: t.translate('modules.submission.sptForm.1770.DetailLampIVB.NM_PBR_PINJAMAN'),
              key: 'namaPemberiPinjaman',
              required: true,
              validation: 'min:4',
              helpText: t.translate('sentence.minimumName'),
            },
            {
              inputType: inputTypes.INPUT,
              label: t.translate('modules.submission.sptForm.1770.DetailLampIVB.ALMT_PBR_PINJAMAN'),
              key: 'alamatPemberiPinjaman',
              required: true
            },
            {
              inputType: inputTypes.INPUT,
              label: t.translate('modules.submission.sptForm.1770.DetailLampIVB.TH_PEMINJAMAN'),
              key: 'tahunPinjaman',
              validation:'digits:4',
              required: true
            },
            {
              inputType: inputTypes.INPUT,
              label: t.translate('modules.submission.sptForm.1770.DetailLampIVB.JML_PINJAMAN'),
              key: 'jumlahPinjaman',
              required: true
            }
          ]
        }
      ]}
      onBeforeChange={(key, value) => (
        ['jumlahPinjaman'].indexOf(key) >= 0
          ? number.format(number.clearFormat(value.replace(/\D/g, '')))
          : ['kodeUtang', 'tahunPinjaman'].indexOf(key) >= 0 
            ? value.replace(/\D/g, '')
            : value
      )}
      onSubmit={(data, callback) => {
        let isDuplicate = utils.isDuplicateObjectInArray(data.daftarKewajiban, [
          'kodeUtang', 'namaPemberiPinjaman', 'alamatPemberiPinjaman', 'tahunPinjaman', 'jumlahPinjaman'
        ])

        if(isDuplicate){
          callback(new Error(t.translate('sentence.duplicateKewajiban')))
        } else {
          props.onSave(storage.keys.SPT_1770_DETAIL_LAMP_IVB, data)
          callback(t.translate('sentence.savedItem'), false)
        }
      }}
      submitLabel={t.translate('column.save')}
    />
  ) : <LoaderInfo/>
}

DetailLampIVB.generate = generate

export default inject('envStore')(observer(DetailLampIVB))
